module.exports = __webpack_public_path__ + "static/media/muffito_logo.a800df90.svg";